"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const api_service_1 = __importDefault(require("./api.service"));
class Feature {
    constructor(apiService) {
        this.initialized = false;
        this.shouldThrowExceptions = false;
        this.apiService = apiService;
    }
    init(options) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.assertCorrectURL(options.baseURL);
                this.shouldThrowExceptions = (_a = options === null || options === void 0 ? void 0 : options.throwExceptions) !== null && _a !== void 0 ? _a : false;
                this.apiService.init({
                    baseURL: options.baseURL,
                    updateIntervalRateMS: options === null || options === void 0 ? void 0 : options.updateIntervalRateMS,
                });
                this.getTokenData = options.getTokenData;
                this.initialized = true;
            }
            catch (err) {
                this.initialized = false;
                throw err;
            }
        });
    }
    isActiveFeature(feature, userToken) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.assertIsInitialized();
                const status = yield this.apiService.getFeatureStatus();
                if (!status[feature] && userToken) {
                    return this.isActiveFeatureForUser(feature, userToken);
                }
                return (_a = status[feature]) !== null && _a !== void 0 ? _a : false;
            }
            catch (err) {
                if (this.shouldThrowExceptions) {
                    throw err;
                }
                return false;
            }
        });
    }
    isActiveFeatureForUser(feature, userToken) {
        try {
            const tokenData = this.getTokenData(userToken);
            return tokenData.featureName === feature;
        }
        catch (err) {
            return false;
        }
    }
    assertCorrectURL(baseURL) {
        try {
            if (baseURL !== `/`) {
                new URL(baseURL);
            }
        }
        catch (err) {
            throw new Error(`BaseURL invalid`);
        }
    }
    assertIsInitialized() {
        if (!this.initialized) {
            throw new Error(`Please initialize feature service by calling init() first`);
        }
    }
}
const apiService = new api_service_1.default();
const FeatureService = new Feature(apiService);
exports.default = FeatureService;
//# sourceMappingURL=index.js.map